import { I18nService } from '@goparrot-dashboard/i18n';
import * as React from 'react';
import { Redirect, Route, Switch, useRouteMatch } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import { AuthLayout } from './layouts/AuthLayout';
import { ConfirmAccountPage } from './pages/ConfirmAccount';
import { ConfirmInvitePage } from './pages/ConfirmInvite';
import { ForgotPasswordPage } from './pages/ForgotPassword';
import { LoginPage } from './pages/Login';
import { RegisterPage } from './pages/Register';
import { ResetPasswordPage } from './pages/ResetPassword';

export const AuthModule: React.FC<React.PropsWithChildren<unknown>> = () => {
  const { path } = useRouteMatch();

  return (
    <AuthLayout>
      <Helmet>
        <meta name="robots" content="noindex, nofollow" />
      </Helmet>
      <I18nService prefix="page.auth">
        <Switch>
          <Route path={`${path}/sign-in`} render={() => <LoginPage />} />
          <Route path={`${path}/sign-up`} render={() => <RegisterPage />} />
          <Route path={`${path}/forgot-password`} render={() => <ForgotPasswordPage />} />
          <Route path={`${path}/reset-password/:token`} render={() => <ResetPasswordPage />} />
          <Route path={`${path}/confirm-account/:token`} render={() => <ConfirmAccountPage />} />
          <Route path={`${path}/confirm-invite/:token`} render={() => <ConfirmInvitePage />} />
          <Route path="*" render={() => <Redirect to={`${path}/sign-in`} />} />
        </Switch>
      </I18nService>
    </AuthLayout>
  );
};
